module.exports = __webpack_public_path__ + "img/caravans-for-hire-no.d2c8284.svg";